import {
  CardBodyProps,
  CardHeaderProps,
  CardRootProps,
  Heading,
  HeadingProps,
  Icon,
  Spacer,
  Card,
} from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { MdEdit } from 'react-icons/md';
import { MCard } from '../../components/Monetize';

interface QuoteShareEditableCardProps {
  title: string;
  disabled?: boolean;
  props?: {
    cardProps?: CardRootProps;
    cardHeaderProps?: CardHeaderProps;
    headingProps?: HeadingProps;
    cardBodyProps?: CardBodyProps;
  };
  icon?: IconType;
  onClick: () => void;
  children: React.ReactNode;
}

export const QuoteShareButtonCard = ({
  title,
  disabled,
  props,
  icon,
  onClick,
  children,
}: QuoteShareEditableCardProps) => {
  const cardContent = (
    <>
      <Card.Header {...props?.cardHeaderProps}>
        <Heading
          fontSize="lg"
          alignItems="center"
          display="flex"
          gap={2}
          className="card-title"
          {...props?.headingProps}
        >
          {icon && <Icon boxSize="1.5rem" as={icon} />}
          {title}
          <Spacer />
          {!disabled && (
            <Icon
              boxSize="1rem"
              color="tGray.darkPurple"
              className="card-edit-icon"
              asChild
            >
              <MdEdit />
            </Icon>
          )}
        </Heading>
      </Card.Header>
      <Card.Body py={2} {...props?.cardBodyProps}>
        {children}
      </Card.Body>
    </>
  );

  return (
    <MCard
      variant="edit"
      asChild={!disabled}
      css={
        disabled
          ? undefined
          : {
              '&:hover .card-title': {
                color: 'tIndigo.base',
              },
              '&:hover .card-edit-icon': {
                color: 'tIndigo.base',
              },
              '&:focus-visible .card-title': {
                color: 'tIndigo.base',
              },
              '&:focus-visible .card-edit-icon': {
                color: 'tIndigo.base',
              },
            }
      }
      _hover={disabled ? undefined : { cursor: 'pointer' }}
      _focusVisible={
        disabled
          ? undefined
          : { boxShadow: 'focus', outline: 'none', borderColor: 'tIndigo.base' }
      }
      aria-label={disabled ? undefined : `Edit ${title}`}
      textAlign="unset"
      {...props?.cardProps}
      onClick={() => (disabled ? undefined : onClick())}
    >
      {disabled ? cardContent : <button type="button">{cardContent}</button>}
    </MCard>
  );
};
